import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-name',
  templateUrl: './card-name.component.html',
  styleUrls: ['./card-name.component.css']
})
export class CardNameComponent implements OnInit {

  @Input() name: string;

  constructor() { }

  ngOnInit() {
  }

}
